import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { buildQuery } from '../exports/queryStringBuilder'

const api = async (method, path, params) => axios[method](path, params)

const state = {
    template: null,
    query: '',
    templates: [],
    filters: {},
    pagination: null,
    options: {},
    templateItems: [],
}


const getters = {
    ams_integration_codes: state => state.options.ams_integration_codes,
    rpa_integration_codes: state => state.options.rpa_integration_codes,
}

const mutations = {
    set_options(state, payload) {
        state.options = payload
    },
    set_template(state, payload) {
        state.template = payload
    },
    set_templates(state, payload) {
        console.log(payload, "set_templates")
        state.templates = payload
    },
    set_templateItems(state, payload) {
        console.log(payload, "set_templateItems")
        state.templateItems = payload
    },
    set_pagination(state, payload) {
        state.pagination = payload
    },

    SET_FILTERS(state, payload) {
        state.filters = payload
    },

    SET_QUERY(state, payload) {
        state.filters = payload
    },
}

const actions = {
    async create({ commit, state }, payload) {
        try {
            const results = await api('post', `rpa-template`, payload)
            const data = results.data.success.data
            state.templates.push(data);
            commit('set_template', data);
        } catch (err) {
            errorHandler(err)
        }
    },
    async getOptions({ commit, }) {
        try {
            const result = await api('get', `rpa-template/options`)
            const value = JSON.parse(result.data.success.data);
            commit('set_options', value)
        } catch (err) {
            errorHandler(err)
        }
    },

    fetchById({ commit, state }, id) {
        try {
            commit('set_template', state.templates.find(x => x.id == id)
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(
        { commit },
        { query, filters, page: page_no }
    ) {
        try {
            filters = filters || {};
            query = query || "";

            commit("SET_FILTERS", filters);
            commit("SET_QUERY", query);


            page_no = parseInt(page_no) || 1;
            const result = await api('get', `rpa-template?q=${query}&page=${page_no}&${buildQuery(filters)}`);

            const {
                data: templates = [],
                current_page: page = 1,
                per_page: pageSize = 10,
                total = 0,
            } = result.data.success.data || {};
            commit("set_pagination", {
                page,
                pageSize,
                total,
            });
            commit("set_templates", templates);
        } catch (err) {
            errorHandler(err);
        }
    },

    async update({ commit, state }, payload) {
        console.log('update', payload)
        try {
            const results = await api('put', `rpa-template/${payload.id}`, payload)
            const data = results.data.success.data
            const idx = state.templates.findIndex(x => x.id == data.id)
            state.templates.splice(idx, 1, data)
            commit('set_template', data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete({ commit, state }, id) {
        try {
            await api('delete', `rpa-template/${id}`)
            const idx = state.templates.findIndex(x => x.id == id)
            state.templates.splice(idx, 1)
            commit('set_template', null)
        } catch (err) {
            errorHandler(err)
        }
    },
    /////////////////////////////////////////
    async createItem({ state }, payload) {
        try {
            const results = await api('post', `rpa-template/${state.template.id}/items`, payload)
            const data = results.data.success.data
            state.templateItems.push(data);
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchItems(
        { commit },
    ) {
        try {
            const result = await api('get', `rpa-template/${state.template.id}/items`);
            commit("set_templateItems", result.data.success.data || []);
        } catch (err) {
            errorHandler(err);
        }
    },

    async updateItem({ state }, payload) {
        console.log('updateItem:', payload)
        try {
            const results = await api('put', `rpa-template/${state.template.id}/items/${payload.id}`, payload)
            const data = results.data.success.data
            const idx = state.templateItems.findIndex(x => x.id == data.id)
            state.templateItems.splice(idx, 1, data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async deleteItem({ state }, id) {
        try {
            await api('delete', `rpa-template/${state.template.id}/items/${id}`)
            const idx = state.templateItems.findIndex(x => x.id == id)
            state.templateItems.splice(idx, 1)
        } catch (err) {
            errorHandler(err)
        }
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
